export default __webpack_public_path__ + "static/media/ed2mit2021tuto01.01_intro-data-spaces-v02.1383014d.pdf";